import {
  Box,
  Grid,
  LinearProgress,
  linearProgressClasses,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";

import useStyles from "./styles";

import dayjs from "dayjs";
import LineChartComponent from "../../lineComponent";
import { Stack } from "@mui/system";
import DatagridComponent from "../../datagridComponent";
import { rangeMax } from "../../../utils/rangeMaxDate";

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
const timeZone = "America/Sao_Paulo";
export default function AvailabilityGraphComponent(params) {
  const {
    data = [],
    dataHistory = [],
    titleGraph = "",
    titleHistory = "",

    loading = false,
    loadingHistory = false,
    handleAplicarZoom = () => {},
    isZoomEnabled = false,
  } = params;

  const theme = useTheme();
  const styles = useStyles(theme);

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || payload.length === 0) return null;

    const { clock, value } = payload[0].payload;

    return (
      <Box
        sx={{
          bgcolor: theme.palette.paletteCharts.lineCharts,
          padding: "8px",
          borderRadius: "8px",
        }}
      >
        <Typography fontSize={"14px"}>
          {`Data: ${dayjs.unix(clock).format("DD/MM/YY HH:mm")}`}
        </Typography>

        <Stack direction={"row"} alignItems={"center"} gap={"4px"}>
          <Box
            sx={{
              bgcolor:
                theme.palette.cardGraphic.graphColor[
                  value > 80
                    ? "green"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "red"
                ],
              width: "14px",
              height: "14px",
              borderRadius: "2px",
              border: `1px solid ${
                theme.palette.cardGraphic.graphColor[
                  value > 80
                    ? "green"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "red"
                ]
              }`,
            }}
          />
          <Typography fontSize={"14px"}>
            Disponibilidade: {value?.toFixed(2)}%
          </Typography>
        </Stack>
      </Box>
    );
  };
  const columnsHistory = [
    {
      field: "month",
      headerName: "Mês",
      width: 100,
      valueFormatter: (params) => {
        const monthNames = [
          "",
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro",
        ];
        return monthNames[parseInt(params, 10)];
      },
    },
    {
      field: "mean",
      headerName: "Média",
      width: 150,
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
          }}
        >
          <LinearProgress
            variant="determinate"
            value={params.value}
            sx={{
              flex: 1,
              height: 4,
              borderRadius: 6,
              [`&.${linearProgressClasses.colorPrimary}`]: {
                backgroundColor:
                  theme.palette.cardGraphic.colorPogressLine.dark["green"],
              },
              [`& .${linearProgressClasses.bar}`]: {
                borderRadius: 6,
                backgroundColor:
                  theme.palette.cardGraphic.colorPogressLine.light["green"],
              },
            }}
          />
          <Typography variant="body2" sx={{ fontSize: 12 }}>
            {params.value}%
          </Typography>
        </Box>
      ),
    },
  ];

  function formatValue(value) {
    return `${Number(value).toFixed(1)}%`;
  }

  return (
    <Box sx={styles.containerComponent}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} lg={4}>
          <Paper elevation={3} sx={styles.paperDatagrid}>
            <Box sx={styles.paper}>
              {loadingHistory && <LinearProgress sx={styles.linearProgress} />}
              <Typography sx={{ fontWeight: "bold" }}>
                {titleHistory}
              </Typography>
            </Box>

            <DatagridComponent columns={columnsHistory} rows={dataHistory} />
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} lg={8}>
          <Paper
            elevation={theme.palette.mode == "dark" ? 0 : 3}
            sx={styles.paper}
          >
            {loading && <LinearProgress sx={styles.linearProgress} />}
            <Typography sx={{ fontWeight: "bold", marginBottom: 2 }}>
              {titleGraph}
            </Typography>

            <Box width="100%" height={150}>
              <LineChartComponent
                data={data}
                isZoomEnabled={isZoomEnabled}
                onZoomChange={(range) => {
                  // Use .unix() para interpretar o valor como segundos
                  const startDate = dayjs.unix(range.start).tz(timeZone);
                  const endDate = dayjs.unix(range.end).tz(timeZone);

                  handleAplicarZoom(startDate, endDate);
                }}
                maxValuebps={100}
                maxTicks={10}
                mainColor={theme.palette.cardGraphic.graphColor["green"]}
                mainLineColor={theme.palette.cardGraphic.graphColor["green"]}
                yOptions={{ tickFormatter: formatValue }}
                customTooltip={CustomTooltip}
                xOptions={
                  rangeMax(data)
                    ? {}
                    : {
                        tickFormatter: (clock) =>
                          dayjs.unix(clock).tz(timeZone).format("DD/MM HH:mm"),
                      }
                }
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
